module.exports = __webpack_public_path__ + "static/media/p1_img2.10b8681e.png";